import React, { FC, useState } from "react";
import { motion } from "framer-motion";
import Portal from "HOC/Portal";
import Close from "Assets/images/close.svg";
import injectSheet from "react-jss";
import styleSheet from "./styles";

interface Props {
  classes?: any;
  title?: string;
  message?: string;
  onClose?: () => void;
}

const Message: FC<any> = (props: Props) => {
  // Destructure props //
  const { classes, onClose, title, message } = props;

  // Local state //
  const [promptAnimationComplete, setPromptAnimationComplete] = useState(false);

  // Animations //
  const sceneAnimations = {
    open: {
      opacity: 1,
      transition: {
        duration: 0.5,
        onComplete: () => {
          setTimeout(() => {
            setPromptAnimationComplete(true);
          }, 4000);
        },
      },
    },
    closed: {
      opacity: 0,
      transition: {
        duration: 0.5,
        onComplete: onClose,
      },
    },
  };

  return (
    <Portal>
      <motion.div
        initial={{ opacity: 0 }}
        animate={promptAnimationComplete ? "closed" : "open"}
        variants={sceneAnimations}
        className={classes.switchToMap}
      >
        <button
          onClick={() => setPromptAnimationComplete(true)}
          type="button"
          className={classes.closePrompt}
        >
          <Close />
        </button>
        <h2>{title}</h2>
        <p>{message}</p>
      </motion.div>
    </Portal>
  );
};

Message.defaultProps = {
  classes: [],
  onClose: Function,
  title: "",
  message: "",
};

export default injectSheet(styleSheet)(Message);
